<script lang="ts">
  import { ArrowRight } from 'lucide-svelte';
</script>

<section class="py-20 md:py-32 px-4 md:px-8">
  <div class="max-w-7xl mx-auto">
    <div class="relative overflow-hidden bg-white/5 rounded-2xl border border-white/10 backdrop-blur-sm" style="box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.2)">
      <div class="relative z-10 px-6 md:px-8 py-16 md:py-24 text-center">
        <h2 class="text-white mb-4 md:mb-6 text-3xl sm:text-4xl md:text-5xl lg:text-6xl max-w-3xl mx-auto leading-tight">
          Ready to transform your AI infrastructure?
        </h2>
        <p class="text-slate-500 text-base md:text-lg mb-10 md:mb-12 max-w-2xl mx-auto leading-relaxed">
          Join our happy clients already using BuyKeys to power their AI applications with confidence.
        </p>

        <div class="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center items-center mb-6 md:mb-8">
          <a
            href="#pricing"
            class="w-full sm:w-auto px-6 md:px-8 py-3 md:py-3.5 bg-white text-black rounded-md transition-all hover:-translate-y-0.5 group flex items-center justify-center gap-2 text-sm md:text-base"
            style="box-shadow: 0 4px 14px 0 rgba(255, 255, 255, 0.2), 0 8px 24px 0 rgba(255, 255, 255, 0.12)"
          >
            Get Started Now
            <ArrowRight class="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </a>
          <a
            href="https://t.me/BuyKeysSupport"
            target="_blank"
            rel="noopener noreferrer"
            class="w-full sm:w-auto px-6 md:px-8 py-3 md:py-3.5 bg-transparent border border-white/20 text-white rounded-md transition-all hover:bg-white/5 text-sm md:text-base inline-block text-center"
          >
            Contact Us
          </a>
        </div>

        <p class="text-slate-600 text-xs uppercase tracking-wider">
          Vibecode · Get rich · ##FF
        </p>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <footer class="mt-20 md:mt-32 text-center pb-8 md:pb-12 border-t border-white/5 pt-8 md:pt-12">
    <div class="flex flex-wrap items-center justify-center gap-6 md:gap-12 mb-6 md:mb-8 text-slate-600 px-4">
      <a href="https://t.me/BuyKeysSupport" target="_blank" rel="noopener noreferrer" class="hover:text-white transition-colors text-xs md:text-sm">Support</a>
      <a href="https://t.me/BuyKeysStore" target="_blank" rel="noopener noreferrer" class="hover:text-white transition-colors text-xs md:text-sm">Community</a>
      <a href="#pricing" class="hover:text-white transition-colors text-xs md:text-sm">Pricing</a>
    </div>
    <p class="text-slate-700 text-xs md:text-sm px-4">© 2025 BuyKeys. All rights reserved.</p>
  </footer>
</section>
